import fetchData from "@/lib/Fetchers/fetchData";
import { sendKibanaLog } from "./sendKibanaLog";
import {
  AlternativeFlightsResponse,
  AlternativeFlightOffer,
} from "@/lib/Types/AlternativeFlight";
import { AppConfig } from "@/lib/Types/AppConfig";

interface AlternativeFlightsParams {
  bookingCode: string;
  offerId: string;
  transactionId?: string;
  departureAirport: string;
  destinationAirport: string;
  giataId: string;
  objectCode: string;
  accomodationCode: string;
  duration: number;
  from: string;
  to: string;
  roomCode: string;
  roomType: string;
  mealType: string;
  ttMealType?: string;
  tourOperatorCode: string;
  roomAddition?: string;
  debugMode?: boolean;
  appConfig: AppConfig;
}

export async function fetchAlternativeFlights(
  params: AlternativeFlightsParams,
): Promise<AlternativeFlightOffer[]> {
  const { envConfig, viewMode, searchParams } = params.appConfig;

  const paramsObject = {
    bookingCode: params.bookingCode,
    offerId: params.offerId,
    departureAirport: params.departureAirport,
    destinationAirport: params.destinationAirport,
    giataId: params.giataId,
    objectCode: params.objectCode,
    accomodationCode: params.accomodationCode,
    duration: params.duration,
    from: params.from,
    to: params.to,
    m: viewMode.mandator,
    p: viewMode.profile,
    roomCode: params.roomCode,
    roomType: params.roomType,
    mealType: params.mealType,
    tourOperatorCode: params.tourOperatorCode,
    rooms: searchParams.rooms || "25,25",
    travellers: (searchParams.rooms || "25,25").replaceAll(";", ","),
    ...(params.ttMealType && { ttMealType: params.ttMealType }),
    ...(params.transactionId && { transactionId: params.transactionId }),
    ...(params.debugMode && { roomAddition: params.roomAddition }),
    ...(params.debugMode && { debugMode: params.debugMode }),
  };

  const url = `${envConfig.api}/comvel-flight-info-service/rest/alternativeFlights`;

  sendKibanaLog({
    envConfig,
    transactionId: params.transactionId,
    message: "ALTERNATIVE FLIGHTS START",
    component: "alternativeFlights",
    jsonMessage: paramsObject,
    category: "debug",
    searchId: searchParams.searchId,
  });

  const data = await fetchData({
    url,
    method: "GET",
    params: paramsObject,
    envConfig,
    service: "alternativeFlights",
    transactionId: params.transactionId,
    searchId: searchParams.searchId,
  });

  const isError = data?.apiError;

  sendKibanaLog({
    envConfig,
    transactionId: params.transactionId,
    message: `ALTERNATIVE FLIGHTS ${isError ? "FAIL" : "SUCCESS"}`,
    component: "alternativeFlights",
    category: "debug",
    searchId: searchParams.searchId,
    jsonMessage: isError
      ? data.message
      : { count: data.flightOfferList?.length },
  });

  if (isError) {
    return [];
  }

  return (data as AlternativeFlightsResponse).flightOfferList || [];
}
